
import { MenuNode } from './menu';

export class User {
    id_usuario: number;
    username: string;
    firstName: string;
    lastName: string;
    token: string;
    ind_estado: number;
    menu : MenuNode[];
    actions : any[];
    pefiles : any[];
}